import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product, ProductRate, StandardCost } from 'src/app/models';
import { GenericResource } from 'src/app/resources';
import { ApiService } from 'src/app/services/api.service';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsCostsAddComponent } from '../products-costs-add/products-costs-add.component';
import { formatCurrency } from '@angular/common';
import { ProductsStorageService } from '../../product-storage.service';
import { firstValueFrom } from 'rxjs';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-product-costs',
    templateUrl: './product-costs.component.html',
    styleUrl: './product-costs.component.sass',
    standalone: false
})
export class ProductCostsComponent implements OnInit {


  @Input() product?: Product;
  ratios?: ProductRate;
  productStandardCostsRes?: GenericResource<StandardCost>;
  createProductCostComponent = ProductsCostsAddComponent;
  ratiosValues: { value: string | number | Date | null, caption: string }[] = [];
  @ViewChild ('grid') dataGrid?: DxDataGridComponent;
  

  constructor(protected translationService: TranslateService, protected api: MasterApiService, protected productData: ProductsStorageService) { }

  async ngOnInit(): Promise<void> {
    this.productStandardCostsRes = this.api.resources.product.productStandardCosts(this.product!.id);

    
    // Set ratios values
    this.ratios = await firstValueFrom(this.api.resources.product.productRatios(this.product!.id).getAll())as unknown as ProductRate;
    this.ratiosValues = [
      { caption: 'entity.product.lastBatch', value: this.ratios.lastBatch?.batch },
      { caption: 'entity.product.batchDate', value: this.ratios.lastBatch?.lastDate },
      { caption: 'entity.product.batchCost', value: this.ratios.lastBatch?.cost },
      { caption: 'entity.product.averageCost', value: this.ratios.costAverage }
  ];
  }
    getFormattedPriceInCompanyCurrency(price:number|undefined) {
      if (!price && price !== 0)
        return '';
  
      return formatCurrency(price, this.translationService.currentLang, this.productData.currencyCompany!.currencySymbol, this.productData.currencyCompany!.code, '.0' + this.productData.currencyCompany!.decimals);
    }
    async editorComponentClosed() {
      await this.dataGrid?.instance.refresh();
    }

}
